import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { BRAND, NAV } from "@/data/brand";

function FooterLink({ link }) {
  if (link.href.startsWith("/#") || link.href.startsWith("#")) {
    return <a href={link.href} className="text-white/75 hover:text-white text-[15px]">{link.label}</a>;
  }
  return <Link to={link.href} className="text-white/75 hover:text-white text-[15px]">{link.label}</Link>;
}

export default function SiteFooter() {
  return (
    <footer className="bg-[#0D1B2A] text-white">
      <div className="max-w-[1240px] mx-auto px-5 sm:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-baseline">
              <span className="font-serif-d text-[28px] md:text-[34px] text-white tracking-[-0.01em] font-medium">Life</span>
              <span className="font-serif-d text-[28px] md:text-[34px] text-[#F57F17] tracking-[-0.01em] font-semibold ml-[1px]">IQ</span>
            </div>
            <p className="mt-3 text-white/75 max-w-md text-[16px]">{BRAND.tagline}</p>
          </div>

          <div className="md:col-span-4">
            <div className="text-[12px] uppercase tracking-[0.18em] text-white/55 font-semibold">Explore</div>
            <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2.5">
              {NAV.map((l) => (
                <li key={l.href}><FooterLink link={l} /></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[12px] uppercase tracking-[0.18em] text-white/55 font-semibold">LifeIQ EdTech</div>
            <ul className="mt-4 space-y-2.5 text-[15px] text-white/85">
              <li className="flex items-center gap-2"><MapPin size={15} className="opacity-70" /> {BRAND.city}, India</li>
              <li><a href={`mailto:${BRAND.email}`} className="flex items-center gap-2 hover:text-white"><Mail size={15} className="opacity-70" /> {BRAND.email}</a></li>
              <li className="flex items-center gap-2"><Phone size={15} className="opacity-70" /> {BRAND.phone}</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-[13px] text-white/55">
          <div>© {new Date().getFullYear()} LifeIQ EdTech. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
